import * as enMessages from './data/en.json'

export default () => {
  const translates = { ...enMessages.default }
  return Promise.resolve(translates)
}
